import { render, staticRenderFns } from "./Cxp.vue?vue&type=template&id=0ff8c5a8&scoped=true"
import script from "./Cxp.vue?vue&type=script&lang=js"
export * from "./Cxp.vue?vue&type=script&lang=js"
import style0 from "./Cxp.vue?vue&type=style&index=0&id=0ff8c5a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff8c5a8",
  null
  
)

export default component.exports